module.exports = __webpack_public_path__ + "img/territorio.d7001f56.svg";